import {Injectable} from "@angular/core";
import {BaseApiService} from "../services/base-api-service";
import {ApiType} from "../enums/api-type";
import {RequestType} from "../enums/RequestType";
import {Observable} from "rxjs";
import {Category} from "../interfaces/Category";
import {CategoriesResponse} from "../interfaces/CategoriesResponse";

@Injectable({providedIn: 'root'})
export class CategoryApi {

  constructor(
    private baseApiService: BaseApiService
  ) {
  }

  getAllCategories(pageSize?: number, page?: number): Observable<CategoriesResponse> {
    let params: { [key: string]: any } | null = null;
    if(pageSize || page)
    {
      params = {
        "pageSize": pageSize ?? 10,
        "page": page ?? 1,
      };
    }

    return this.baseApiService.call<any, CategoriesResponse>({
      apiType: ApiType.getAllCategories,
      requestType: RequestType.GET,
      body: params
    })
  }

  getCategoryById(categoryId: string): Observable<Category> {
    return this.baseApiService.call<null, Category>({
      apiType: ApiType.getCategoryById,
      requestType: RequestType.GET,
      pathVariables: [categoryId]
    })
  }

}
